import type { LucideIcon } from 'lucide-react';
import type { Category } from './category';
import { categoryNameToIcon } from '../utils/categoryIcon';

export interface HomeCategoryItem {
  id: number;
  name: string;
  slug: string;
  image: string | null;
  icon: LucideIcon;
  products_count?: number;
}

export function categoryToHomeItem(category: Category): HomeCategoryItem {
  return {
    id: category.id,
    name: category.name,
    slug: category.slug,
    image: category.image,
    icon: categoryNameToIcon(category.name),
    products_count: category.products_count,
  };
}
